import { createReducer } from 'redux-act'

const user = createReducer({}, null)

export default user



// WEBPACK FOOTER //
// app/javascript/src/reducers/user.js